import { environment } from 'environments/environment';
import { PostHogGlobalProperties } from './posthog-properties.types';
import { detectarContextoEmbed } from './posthog-embed';

export const POSTHOG_APP_NAME = 'center_web' as const;

export function montarPropriedadesGlobais(
  extras: Partial<PostHogGlobalProperties> = {}
): PostHogGlobalProperties {
  const contexto = detectarContextoEmbed();

  const globais: PostHogGlobalProperties = {
    app_name: POSTHOG_APP_NAME,
    ambiente: environment.ambiente as PostHogGlobalProperties['ambiente'],
    app_version: environment.version,
    contexto: contexto.embedded ? 'iframe' : 'standalone'
  };

  if (contexto.embedOrigin) {
    globais.embed_origin = contexto.embedOrigin;
  }

  for (const [chave, valor] of Object.entries(extras)) {
    if (valor !== undefined) {
      (globais as Record<string, unknown>)[chave] = valor;
    }
  }

  return globais;
}
